module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("iCuAR"))).then(() => parcelRequire('1iHdE'));